import Grid from '@mui/material/Grid';

import { PartnerInformationSummaryProps } from '../../step2_PartnerInformation';
import { Field } from '../Field';

const VatNumberField = ({ formSummaryData }: PartnerInformationSummaryProps) => {
    return formSummaryData?.pi_vatNumber && formSummaryData?.pi_vatNumber.length > 0 ? (
        <Field label="VAT Number" value={formSummaryData?.pi_vatNumber} />
    ) : (
        <Grid item lg={6} xs={12} />
    );
};

export default VatNumberField;
